import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {AppIntro, OnboardingStepDto, OnboardingDto} from "../../types/ob.interfaces";
import {OnboardingService} from "../../api/onboarding.service";
import {CarouselPageEvent} from "primeng/carousel";
import {AppMessageService} from "../../../core/service/app-message.service";
import {MessageHelper} from "../../../core/helper/message-helper";


@Component({
  selector: 'app-intro',
  templateUrl: './app-intro.component.html',
  styleUrls: ['app-intro.component.scss']
})
export class AppIntroComponent extends CoreComponent implements OnInit {

  appIntro: OnboardingDto | undefined;
  infoSteps: OnboardingStepDto[] = [];
  @Output() onContinue = new EventEmitter();

  currentCarouselIndex: number = 0; // Default to the first item

  constructor(protected appIntroApiService: OnboardingService, protected messageService: AppMessageService) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
    this.initComponent();
  }

  initComponent() {
    this.appIntroApiService.getOnboardingOnRegistration().subscribe((res: OnboardingDto) => {
      this.appIntro = res;
      this.infoSteps = res.infoSteps;
      this.refreshComponent();
    }, error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);
    })
  }


  refreshComponent() {
    this.initialized = true;
  }

  handleCarouselPageChange(event: CarouselPageEvent) {
    if (event?.page) {
      this.currentCarouselIndex = event.page;
    }
  }


}
